export * from "./detalles";
